import { AddToPhotos } from '@mui/icons-material';
import { Col, Progress, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import { FileUploader } from "react-drag-drop-files";
import styled from 'styled-components';
import COLOR from "utils/constants/color";
import ModalMenu from "components/Modals";
import { imageUploader } from "utils/methods/imageUploader";
import MultiFileUploader from "components/UI/admin/MultifileUploadGallery";
import * as Sentry from '@sentry/react';
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import { IMAGE_FILE_TYPE, UPLOAD_IMAGE_TO_FIREBASE } from "utils/constants/enum"


const ImageContainer = styled.div`
    height: auto;
    flex: 1;
    // height:70vh;
`;

const Images = styled.img`
    background-color: ${COLOR.white};
    box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);
    max-height: 30%;
    max-width: 100%;
    height: 100px;
    object-fit: contain;
    border-radius:8px;
`;

const FileUploadArea = styled.div`
    height: 100%;
    border: 1px dashed gray;
    padding: 5px 12px;
    min-height: 50px;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

const Text = styled.div`
    font-size: 12px;
`;
const Column = styled(Col)`
display: flex;
    justify-content: center;
    align-items: center;
}
`
const ImageWrapper = styled.div`
    border: 1px dashed;
    padding: 10px;
    // border-radius: 8px;
    margin-bottom: 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #f9f9f9;
    padding-top:23px;
`;

export default function CloneBookImage({ src, onChange, style, pageId, setImageCoverLoader = () => {} }) {
    const showAlert = useAlert();
    const [pagePoster, setpagePoster] = useState(src)
    const [loader, setLoader] = useState(false)
    const [loadingMap, setLoadingMap] = useState(0)
    const [imageModal,setImageModal] = useState(false);

    useEffect(() => {
        setpagePoster(src)
    }, [src])
    const handleChange = (file) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        uploadToStorage(file, pageId)
        reader.onloadend = function (e) {
            let v = reader.result;
            setpagePoster(v)
            // onChange({ url: v, pageId })
        };
    };
    const uploadToStorage = async (file, index) => {
        if (file) {
            try {
                setLoader(true);
                setImageCoverLoader(true);
                const onProgress = per=>{
                    setLoadingMap(per);
                    setLoader(true);
                    setImageCoverLoader(true);
                }               
                const download_url = await imageUploader(file, onProgress,UPLOAD_IMAGE_TO_FIREBASE)
                if (download_url) {
                    onChange({ url: download_url, pageId: index });
                } else {
                    showAlert("Unable to upload image.", 'error')
                }
            } catch (error) {
                console.error("Upload error:", error);
                Sentry.captureException(`293 Error uploading image: ${error}`);
                showAlert("Unable to upload image.", 'error')
            } finally {
                setLoader(false);
                setLoadingMap(0);
                setImageCoverLoader(false)
            }
        } else {
            console.log("No file to upload.");
        }
    };
   const onSelectImage = (v, index) => {
        onChange({ url: v, pageId: index });
        setpagePoster(v)
    }
    return (
        <ImageContainer onContextMenu={(e) => { }} style={style}>
            <ModalMenu type="imageModal" image={pagePoster} open={imageModal} close={() => setImageModal(false)}  />
            <ImageWrapper empty={!pagePoster} >
                <Images src={pagePoster} className={"cursor-zoomIn"} onClick={() => setImageModal(true)} />
                 <MultiFileUploader inModal onSelect={v=>{ onSelectImage(v, pageId) }}/>
                <FileUploader
                    classes={"file-uploader-cover answerFileUploader"}
                    handleChange={handleChange}
                    name="file"
                    types={IMAGE_FILE_TYPE}

                >
                    <FileUploadArea>
                        {loader && <Progress type="line" percent={loadingMap} size={"small"} className={"fileProgress"} showInfo={false} />}
                        <Row className="box box-1" style={{ display: "flex", justifyContent: "space-between" }}>
                            <Column >
                                <AddToPhotos color="primary" />
                            </Column>
                            <Column>
                                <Text>
                                    Upload or drop a file right here
                                </Text>
                            </Column>
                            <Column>
                                <Text>
                                    {IMAGE_FILE_TYPE.join(",")}
                                </Text>
                            </Column>
                        </Row>

                    </FileUploadArea>
                </FileUploader>
            </ImageWrapper>
        </ImageContainer>
    )
}
